export default __webpack_public_path__ + "static/aaron_haynes-6b539acb395b5af83b75d25ec874e4cf.jpg";